import React, { useState, useEffect } from "react";
// @material-ui/core components
import { Grid, Tabs, Tab } from "@material-ui/core";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import tableStyles from "../../../../assets/jss/components/tableStyle";
import styles from "../../../../assets/jss/layouts/appStyle";
// core components
import { LOCALE } from "../../../../properties/Locale";
import AuthorshipTypeComponent from "./authorshipType/AuthorshipTypeComponent";
import AuthorshipRoleComponent from "./authorshipRole/AuthorshipRoleComponent";
import AuthorshipSchemaPointComponent from "./authorshipSchemaPoint/AuthorshipSchemaPointComponent";

const useStyles = makeStyles(styles, tableStyles);

export default function AuthorshipConfigComponent(props) {
  const classes = useStyles();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newTabIndex) => {
    setTabIndex(newTabIndex);
  };

  return (
    <div>
      <Grid container style={{ paddingTop: "25px" }}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={LOCALE.authorship_type} />
          <Tab label={LOCALE.training_role} />
          <Tab label={LOCALE.schema_points} />
        </Tabs>
        {tabIndex === 0 && (
          <AuthorshipTypeComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 1 && (
          <AuthorshipRoleComponent gradingSchemaId={props.gradingSchemaId} />
        )}
        {tabIndex === 2 && (
          <AuthorshipSchemaPointComponent
            gradingSchemaId={props.gradingSchemaId}
          />
        )}
      </Grid>
    </div>
  );
}
